import { Component, Input } from "@angular/core";
import { CHART_IMAGES } from "@app/shared/constants/chart-images.constants";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";

@Component({
    selector: "app-report-pdf-index",
    imports: [SharedMaterialModule, SharedDsnModule],
    styles: [
        `
            .container {
                background-color: var(--background-color-secondary);
                border-radius: var(--border-radius-8);
                padding: var(--spacing-8);
                gap: var(--spacing-12);
                .fa-bars,
                .fa-hand-pointer {
                    font-size: var(--font-size-14);
                    color: var(--color-text-primary);
                }
                .list-wrapper {
                    flex-wrap: wrap;
                    .card-indicator {
                        padding: var(--spacing-4) var(--spacing-8);
                        background-color: var(--background-color-primary);
                        border-radius: var(--border-radius-8);
                        border: 1px solid var(--color-border-light);
                        height: 82px;
                        min-height: 82px;
                    }
                }
            }
        `
    ],
    template: `
        <div class="container" fxLayout="column">
            <div class="gap-8" fxLayout="row" fxLayoutAlign="start center">
                <i class="fa-solid fa-bars"></i>
                <p class="text-12-bold color-text-primary">Índice</p>
            </div>
            <div class="gap-8" fxLayout="row" fxLayoutAlign="start center">
                <p class="text-10-semi-bold color-text-primary">
                    Clique nas seções para navegar no documento
                </p>
                <i
                    class="fa-solid fa-hand-pointer color-text-primary"
                    style="transform: rotate(-25deg)"
                ></i>
            </div>
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
                class="list-wrapper"
            >
                @for (item of visualizations; track $index) {
                    <a
                        [href]="'#Visualization' + item._id"
                        fxLayout="column"
                        fxFlex="33.3"
                        style="padding: var(--spacing-4); text-decoration: underline; text-decoration-color: var(--color-text-primary);"
                        (click)="onVisualizationClick(item, $event)"
                    >
                        <div class="card-indicator" fxLayout="column" fxFlex>
                            <p
                                class="text-10-regular color-text-primary"
                                style="
                                            width: 100%;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            overflow: hidden;
                                        "
                            >
                                {{ item.name }}
                            </p>
                            @if (showSourceLabel) {
                                <p
                                    class="text-10-regular color-text-primary"
                                    style="
                                            width: 100%;
                                            text-overflow: ellipsis;
                                            white-space: nowrap;
                                            overflow: hidden;
                                        "
                                >
                                    Fonte: {{ item.sourceLabel }}
                                </p>
                            }
                            <div
                                fxLayout="column"
                                fxLayoutAlign="center center"
                                fxFlex
                            >
                                <img
                                    style="width: auto; height: 36px"
                                    [src]="this.chartImages[item.type]"
                                />
                            </div>
                        </div>
                    </a>
                }
            </div>
        </div>
    `
})
export class ReportPdfIndexComponent {
    @Input({ required: true })
    visualizations: {
        _id: string;
        name: string;
        type: string;
        sourceLabel?: string;
    }[];
    @Input({ required: false }) showSourceLabel: boolean = false;
    public chartImages: { [key: string]: string } = CHART_IMAGES;

    public onVisualizationClick(
        item: {
            _id: string;
            name: string;
            type: string;
            sourceLabel?: string;
        },
        event: Event
    ): void {
        event.preventDefault();
        const anchor = document.getElementById(`Visualization${item._id}`);
        if (anchor) {
            anchor.scrollIntoView({ behavior: "smooth" });
        }
    }
}
